<template>
  <div class="scroll-y custom-scrollbar">
    <ion-row>
      <ion-col size="12" size-md="10" offset-md="1" size-lg="10" offset-lg="1" size-xl="8" offset-xl="2">
        <div class="padding">

          <div class="text-left">
            <h1 class="h1">Twoje dane</h1>
            <p class="mt-20">
              <svg class="voxion">
                <use xlink:href="#icon-person"></use>
              </svg>
              <span class="inline-block text-bold">{{ getProfile.firstname }} {{ getProfile.lastname }}</span>
            </p>

            <div v-if="getRole !== 'salesman'">
              <p class="mt-20">
                <span class="text-gray text-bold">E-mail:</span><br/>
                <span class="text-light">{{ getProfile.email }}</span>
              </p>
              <p class="mt-20">
                <span class="text-gray text-bold">Numer rachunku bankowego:</span><br/>
                <span class="text-light">{{ getProfile.iban }}</span>
              </p>
              <p class="mt-20">
                <span class="text-gray text-bold">Dane adresowe:</span><br/>
                <span class="text-light">{{ getProfile.place }}</span><br/>
                <span class="text-light">{{ getProfile.zipCode }} {{ getProfile.city }}</span>
              </p>
              <p class="mt-20">
                <span class="text-gray text-bold">Wybór formy prawnej:</span><br/>
                <span v-if="getProfile.entrepreneur === '1'">
                                    <span class="text-light">Prowadzę działalność gospodarczą</span><br/>
                                </span>
                <span v-if="getProfile.entrepreneur === '0'">
                                    <span class="text-light">Nie prowadzę działalności gospodarczej</span><br/>
                                </span>
              </p>

              <div class="mt-20">
                <button class="link" @click="goToEdit" style="font-size: 16px">
                  <svg style="width: 20px">
                    <use xlink:href="#icon-edit"></use>
                  </svg>
                  <span>Edytuj dane</span>
                </button>
              </div>

              <hr/>

              <div class="mt-10">
                <button class="link color-red" @click="goToDelete">
                  <span>Usuń konto</span>
                </button>
              </div>
            </div>

            <hr/>

            <div class="pd-5">
              <span>Wersja aplikacji: {{ version }} {{ baseURLLetter }}</span>
            </div>
          </div>

        </div>
      </ion-col>
    </ion-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { version } from '../../../package.json';
import api from '../../services/Api';
import axios from 'axios';

export default {
  name: 'UserIndex',
  data() {
    return {
      version: version,
      baseURL: null,
      baseURLLetter: null,
    };
  },
  computed: {
    ...mapGetters(['getProfile', 'getRole']),
  },
  methods: {
    axios,
    goToEdit() {
      this.$router.push({ name: 'UserEdit' });
    },
    goToDelete() {
      this.$router.push({ name: 'UserDelete' });
    },
    checkBaseURL() {
      switch (this.baseURL) {
        case 'https://admin.voxpartnersclub.pl/':
          return 'p';
        case 'https://new-voxprodapi.dev-is.pl/':
          return 'np';
        case 'https://voxuatapi.dev-is.pl/':
          return 'u';
        case 'https://new-voxuatapi.dev-is.pl/':
          return 'nu';
        case 'https://voxdevapi.dev-is.pl/':
          return 'd';
        case 'https://new-voxdevapi.dev-is.pl/':
          return 'nd';
        default:
          return '';
      }
    },
  },
  created() {
    this.baseURL = api.defaults.baseURL;
    this.baseURLLetter = this.checkBaseURL();
  },
};
</script>
